module.exports = __webpack_public_path__ + "assets/toolbar-bg-icon-active.1e016d9f.svg";